module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold-Italic.d88d0728.woff2";